import common from './locales/common.json';
import game from './locales/game.json';
import home from './locales/home.json';

const texts = {
  common,
  home,
  game,
};

export default texts;
